import type { EntitySelection, HostServices, OptionsResult } from '@hopdrive/sdk-configs/renderers';
import type { PortalSettingsTarget } from '@hopdrive/feature-portal-products';
import { useGetRooftopUsersQuery } from './getRooftopUsers.query.generated';

/** dataSources.rooftopUsers: the Guest Rides approver picker's options. */
export function useRooftopUsers(entity: EntitySelection): OptionsResult {
  const customerId = entity.level === 'customer' ? entity.entityId : null;
  const { data, loading, error } = useGetRooftopUsersQuery({
    variables: { customerId: customerId ?? 0 },
    skip: customerId === null,
  });
  return {
    options: (data?.users ?? []).map(user => ({ id: user.id, label: user.display_name, sublabel: user.email ?? undefined })),
    loading,
    error,
  };
}

/**
 * The renderer ports Dealer offers on a product Settings tab. Only what a dealer renderer needs:
 * Dealer has no map, secret or asset-upload port, and listing one would mount renderers that
 * expect it.
 */
export function dealerSettingsHostServices(target: PortalSettingsTarget): HostServices {
  return {
    entity: { level: target.level, entityId: target.levelId },
    dataSources: { rooftopUsers: useRooftopUsers },
  };
}
